// import jsCookie from 'js-cookie';

export default {
  get(key) {
    return localStorage.getItem(key);
    // return jsCookie.get(key);
  },
  set(key, value) {
    return localStorage.setItem(key, value);
    // return jsCookie.set(key, value);
  },
  remove(key) {
    localStorage.removeItem(key);
    // jsCookie.remove(key);
  }
}
